// import Api from '@/services/Api'
import axios from 'axios'
/* eslint-disable */
export default {
    index() {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/referee/getAllEnabled`)
    },
    disIndex() {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/referee/getAllDisabled`)
    }
    ,
    post(user) {

        // let params = JSON.stringify(body)
        // console.log(params);

        // let params = {
        //     "username": "axioss",
        //     "passowrd": "wuasaraarar",
        //     "name": "erfaan",
        //   }
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/referee/insert`, JSON.stringify(user), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
    // ,
    // put(visitrequest) {
    //     return Api().put('', )
    // },
    // delete(user) {
    //     return Api().delete('', {
    //         data: { data : user }
    //     })
    // }
}